<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">إضافة باقة صيانة</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/mPackages">باقات الصيانة</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">إضافة باقة</li>
            </ol>
          </div>
        </div>
      </div>
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-10">
            <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
            <mainLoader v-if="mainLoading" />
            <MaintenancePackagesForm v-if="!mainLoading"
              cardTitle="إضافة باقة"
              :issuesList="issuesList"
            />
          </div>
        </div>
      </div>
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import MaintenancePackagesForm from './form.vue';

export default {
  name: 'MaintenancePackagesCreate',
  components: {
    MaintenancePackagesForm,
  },
  data(){
    return {
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      issuesList: [],
    };
  },
  methods: {
    getInitData(){
      this.$http.get('/api/admin/mPackages/init').then(({data}) => {
        this.issuesList = data.issuesList ?? [];
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        this.mainLoading = false;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
  },
  created(){
    this.getInitData();
  }
}
</script>